import { render, staticRenderFns } from "./CaatAssignment.vue?vue&type=template&id=f824ed6c&scoped=true"
import script from "./CaatAssignment.vue?vue&type=script&lang=js"
export * from "./CaatAssignment.vue?vue&type=script&lang=js"
import style0 from "./CaatAssignment.vue?vue&type=style&index=0&id=f824ed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f824ed6c",
  null
  
)

export default component.exports